import type { ReactNode } from 'react'

import { Stack } from '@mui/material'

type Props = {
  width: number | string
  children?: ReactNode
  testid?: string
  rightBorder?: boolean
}

export function FormColumn(props: Props) {
  return (
    <Stack
      position="relative"
      direction="column"
      height="100%"
      flexShrink={0}
      width={props.width}
      alignItems="center"
      data-testid={props.testid}
      borderRight={props.rightBorder ? theme => `1px solid ${theme.palette.divider}` : undefined}
    >
      {props.children}
    </Stack>
  )
}
